import type * as React from 'react';

function SvgChevronsDown(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg height="1em" viewBox="0 0 16 16" width="1em" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M16 16H0V0h16z" />
        <path
          d="M7.306 12.776L.616 6.333A.822.822 0 01.593 5.17l.022-.022a.89.89 0 011.231 0L8 11.074l6.154-5.926a.888.888 0 011.23 0 .822.822 0 01.023 1.163l-.022.022-6.691 6.443a1 1 0 01-1.388 0z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}

export default SvgChevronsDown;
